import React from 'react';
import { SecureDocumentViewer } from './components/SecureDocumentViewer';
import { Document } from './types/documents';
// Mock Data
const MOCK_DOCUMENTS: Document[] = [{
  id: 'DOC-001',
  name: 'Loan Application Form',
  type: 'Application',
  date: 'Jan 15, 2025',
  fileType: 'PDF',
  size: '2.4 MB'
}, {
  id: 'DOC-002',
  name: 'Property Appraisal Report',
  type: 'Appraisal',
  date: 'Jan 22, 2025',
  fileType: 'PDF',
  size: '5.1 MB'
}, {
  id: 'DOC-003',
  name: 'Federal Tax Returns 2023',
  type: 'Tax Document',
  date: 'Jan 10, 2025',
  fileType: 'PDF',
  size: '1.8 MB'
}, {
  id: 'DOC-004',
  name: 'Pay Stubs - Last 3 Months',
  type: 'Income Proof',
  date: 'Jan 12, 2025',
  fileType: 'PDF',
  size: '890 KB'
}, {
  id: 'DOC-005',
  name: 'Bank Statements - Q4 2024',
  type: 'Asset Proof',
  date: 'Jan 18, 2025',
  fileType: 'PDF',
  size: '3.2 MB'
}, {
  id: 'DOC-006',
  name: 'Title Insurance Policy',
  type: 'Legal',
  date: 'Jan 20, 2025',
  fileType: 'PDF',
  size: '1.1 MB'
}];
export function App() {
  return <div className="min-h-screen bg-[#F3F3F3] font-sans text-[#181818] flex flex-col" data-id="element-0">
      {/* Main Content Area */}
      <main className="flex-1 max-w-7xl w-full mx-auto p-4 sm:p-6 flex flex-col gap-6" data-id="element-1">
        <SecureDocumentViewer documents={MOCK_DOCUMENTS} viewerState="default" data-id="element-2" />
      </main>
    </div>;
}